import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";
import FindAllClient from "@/v2/api/client/FindAll";
import FindAllMobilizationClientOptions, {
    ClientOption,
} from "@/v2/api/client/FindAllMobilizationOptions";

interface ClientFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
    // "mobilization" lists all records regardless of assignment (mobilization filters only)
    source?: "default" | "mobilization";
}

export default function ClientFilterComboBox({
    value,
    onChange,
    placeholder = "Select client...",
    disabled = false,
    className,
    label = "Client",
    source = "default",
}: ClientFilterComboBoxProps) {
    const handleSelect = (item: ClientOption | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderEmployeeItem = (client: ClientOption) => (
        <div className="flex flex-col">
            <span>{client.full_name}</span>
            {client.short_code && (
                <span className="text-xs text-muted-foreground">
                    {client.short_code}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<ClientOption>
            label={label}
            labelAlign="items-start"
            queryKey={
                source === "mobilization"
                    ? ["mobilization-client-options"]
                    : ["clients"]
            }
            queryFn={async ({ pageParam, search, limit }) =>
                (source === "mobilization"
                    ? FindAllMobilizationClientOptions
                    : FindAllClient)({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(client: ClientOption) => client.full_name}
            renderItem={renderEmployeeItem}
            placeholder={placeholder}
            searchPlaceholder="Search clients..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
